module.exports = __webpack_public_path__ + "img/mpay-btn.39a68e5b.png";